import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { trackSEOEvents, validateSchema } from "@/lib/seoAnalytics";

interface PageSpecificFAQStructuredDataProps {
  namespace: string;
  faqKey?: string;
}

const PageSpecificFAQStructuredData = ({ 
  namespace, 
  faqKey = 'faq.questions' 
}: PageSpecificFAQStructuredDataProps) => {
  const { t } = useTranslation([namespace]);
  
  const faqDataRaw = t(faqKey, { returnObjects: true });
  
  const faqData = Array.isArray(faqDataRaw) 
    ? (faqDataRaw as Array<{ question: string; answer: string }>).filter(
        item => item.question && item.answer
      )
    : [];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
  
  useEffect(() => {
    try {
      if (faqData.length > 0 && validateSchema(faqSchema)) {
        trackSEOEvents.structuredDataLoaded('FAQPage');
      }
    } catch {}
  }, [t, namespace]);
  
  if (faqData.length === 0) return null;
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default PageSpecificFAQStructuredData;
